<div mat-dialog-content>
    You will be automatically logged off in 3 minutes, unless you click 'Continue'.
</div>
<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px" mat-dialog-actions>
    <button mat-raised-button (click)="onClose()">Continue</button>
</div>
